export default {
  treatmentReport: 'Treatment Report',
  treatmentReports: {
    search: 'Search Doctor Name, Patient',
    selectDay: 'Select Duration',
    selectTreatment: 'Select Treatment',
    day: 'Treatment Date',
    patientName: 'Patient Name',
    numberOpd: 'OPD Number',
    openOpd: 'Open OPD (times)',
    receiveTreatmentService: 'Receive Treatment/Service (times)',
    getCounseling: 'Receive Counseling (times)',
    onLine: 'Online (times)',
    medicalAssistant: 'Medical Assistant',
    medicalDoctor: 'Attending Doctor',
    treatment: 'Treatment',
    total: 'Total',
    list: 'List',
    download: 'Download'
  },
  moneyReceiptReport: 'Money Receipt Report',
  moneyReceiptReports: {
    date: 'Receipt Date',
    productSales: 'Product Sales (THB)',
    formulaSales: 'Formula Sales (THB)',
    serviceSales: 'Service Sales (THB)',
    courseSales: 'Course Sales (THB)',
    totalSales: 'Total Sales (THB)',
    totalDiscounts: 'Total Discounts (THB)',
    netTotal: 'Net Total (THB)',
    cash: 'Cash (THB)',
    transfer: 'Transfer (THB)',
    creditCard: 'Credit Card (THB)',
    refunds: 'Refunds (THB)',
    productCommission: 'Product Commission (THB)',
    productCommissionPercent: 'Product Commission (Percent)',
    formulaCommission: 'Formula Commission (THB)',
    doctorFee: 'Doctor Fee (THB)',
    treatmentFee: 'Treatment Fee (THB)',
    seatFee: 'Seat Fee (THB)',
    actualRevenue: 'Actual Revenue (THB)'
  },
  ingredientQuantityReport: 'Ingredient Quantity Report',
  ingredientQuantityReports: {
    ingredientNo: 'Ingredient Code',
    name: 'Ingredient Name',
    ingredientCategoryInfo: 'Category',
    price: 'Unit Price (THB)',
    qtySold: 'Quantity Sold',
    totalAmount: 'Total Amount (THB)',
    discountAmount: 'Total Discounts (THB)',
    netAmount: 'Net Amount (THB)',
    commissionAmount: 'Formula Commission (THB)',
    refundAmount: 'Refund Amount (THB)',
    actualRevenue: 'Actual Revenue (THB)',
    searchIngredientNo: 'Search Ingredient Code, Ingredient Name',
    selectCategory: 'Select Category'
  },
  productQuantityReport: 'Product Quantity Report',
  productQuantityReports: {
    image: 'Image',
    referenceNo: 'Product Code',
    name: 'Product Name',
    productCategory: 'Category',
    productType: 'Type',
    price: 'Unit Price (THB)',
    qtySold: 'Quantity Sold',
    totalAmount: 'Total Amount (THB)',
    discountAmount: 'Total Discounts (THB)',
    netAmount: 'Net Amount (THB)',
    commissionAmount: 'Product Commission (THB)',
    refundAmount: 'Refund Amount (THB)',
    actualRevenue: 'Actual Revenue (THB)'
  },
  doctorIncomeReport: 'Doctor Income Report',
  doctorIncomeReports: {
    imageUrl: 'Image',
    doctorNo: 'Employee ID',
    doctorName: 'Name',
    doctorTypes: 'Type',
    commission: 'Commission (THB)',
    doctorFee: 'Doctor Fee (THB)',
    treatmentFee: 'Treatment Fee (THB)',
    seatFee: 'Seat Fee (THB)',
    total: 'Total (THB)'
  },
  courseSalesReport: 'Course Sales Report',
  courseSalesReports: {
    referenceNo: 'Course Code',
    name: 'Service Name',
    courseTypeInfo: 'Type',
    price: 'Sale Price (THB)',
    qtySold: 'Quantity Sold',
    totalAmount: 'Total Amount (THB)',
    discountAmount: 'Total Discounts (THB)',
    netAmount: 'Net Amount (THB)',
    doctorFee: 'Doctor Fee (THB)',
    treatmentFee: 'Treatment Fee (THB)',
    actualRevenue: 'Actual Revenue (THB)'
  },
  tableItems: {
    yearly: 'Yearly',
    monthly: 'Monthly',
    custom: 'Custom'
  },
  label: {
    list: 'list'
  },
  placeholder: {
    productCommission: 'Enter Product Commission'
  },
  chooseDuration: 'Choose Duration',
  noData: 'No Data Found'
}
